import React, { Component } from 'react';
import { Page, Tabbar, Tab, Toolbar, Icon, Dialog, Button, ActionSheet } from 'react-onsenui';
import tabs from './tabs';
import Navigator from '../Navigator';
import SwipeableViews from "react-swipeable-views";

class TabBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      installMessageType: '',
      showNotificationPrompt: false,
      active: 1,
      tabStacks: [
        { size: 0 },
        { size: 0 },
        { size: 0 },
        { size: 0 }
      ],
      currentIndex: 0,
    };
  }

  componentDidMount() {
    // check if mobile device
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = !isIos && userAgent.indexOf("android") > -1;

    // Detects if device is in standalone mode
    const isIosStandaloneMode = ('standalone' in window.navigator) && (window.navigator.standalone);
    const isAndroidStandaloneMode = !isIos && window.matchMedia('(display-mode: standalone)').matches;

    // Checks if should display popup notification: 
    if (isIos) {
      if (isIosStandaloneMode) {
        if (window.Notification.permission === "default") {
          console.log('show notification prompt');
          this.setState({ showNotificationPrompt: true });
        }
      } else {
        console.log('show ios install message');
        this.setState({ installMessageType: 'ios' });
      }
    } else if (isAndroid && !isAndroidStandaloneMode) {
      console.log('show android install message');
      this.setState({ installMessageType: 'android' });
    }
  } 

  setActiveTab = (tabIndex) => {
    if (this.state.active === tabIndex) {
      // Force a re-render by resetting the tab stack for the active tab
      const { tabStacks } = this.state;
      tabStacks[tabIndex].size = 0; // Reset the stack size for the active tab
      this.setState({ active: null, tabStacks }, () => {
        this.setState({ active: tabIndex });
      });
    } else {
      // Change tab normally
      this.setState({ active: tabIndex });
    }
  };

  renderToolbar = () => {
    const { active, tabStacks } = this.state;

    return tabStacks[active].size <= 1 && (
      <Toolbar position="top" className={active === 0 ? 'toolbar__dark' : 'toolbar__light'}>
        <div className="">
          <div className={`c-navbar__content c-navbar__content--${active}`}>
            {process.env.REACT_APP_ENVIRONMENT && process.env.REACT_APP_ENVIRONMENT === 'staging' ?
              <h1 className="u-ml-1 u-text-black">Quicky Staging</h1>
              : <>
                <img alt="Quicky" className="c-navbar__logo u-mr-04" src={`/images/logo${active === 0 ? '_white' : ''}.png`} />
                <h1 className={`u-m-0 u-text-large${active > 0 ? ' u-text-black' : ''}`}>BETA</h1>
              </>}
          </div>
        </div>


        {/* <div className="right">
          <Button 
            className="cart-button" 
            modifier="material--flat"
            onClick={() => pushPage(Cart, 'cart')}
          >
            <svg version="1.1" id="svg__cup-with-steam" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 135 234.2">
              <g id="cup">
                <polygon className="st0" points="21.6,228.8 4.6,81.8 129.4,81.8 112.4,228.8"/>
                <path d="M128.9,82.3l-16.9,146H22L5.1,82.3H128.9 M130,81.3H4l17.1,148h91.8L130,81.3L130,81.3z"/>
              </g>
              <g id="steam">
                <path className="st1" d="M51.6,5.4c0,0-8.4,12.1-2.3,23.4c6.5,12.2,7.3,10.7,13.6,23.7c6.1,12.5-2,23.9-2,23.9"/>
                <path className="st1" d="M63,5.4c0,0-8.4,12.1-2.3,23.5c6.5,12.2,7.3,10.7,13.6,23.7c6.1,12.5-2,23.9-2,23.9"/>
                <path className="st1" d="M74.5,5.4c0,0-8.4,12.2-2.3,23.6c6.5,12.2,7.3,10.7,13.6,23.7c6.1,12.5-2,23.8-2,23.8"/>
              </g>
              <g id="liquid_quarter">
                <polygon className="st2" points="112.1,228.3 21.9,228.3 19.9,210.3 114.1,210.3"/>
              </g>
            </svg>
          </Button>
        </div>  */}

      </Toolbar>
    );
  }

  handleStackChange = (stackSize) => {
    const { active, tabStacks } = this.state;

    let newTabStacks = tabStacks;
    newTabStacks[active].size = stackSize;

    this.setState({ tabStacks: newTabStacks });

    console.log(this.state.tabStacks, stackSize);
  }

  renderTabs = (activeIndex, tabbar) => {
    return tabs.map((tab, i) => ({
      content: 
        <Navigator 
          tab={tab}
          key={`content-${i}-${activeIndex}`}
          onStackChange={this.handleStackChange}
          swipeable={true}
          setActiveTab={this.setActiveTab}
          activeIndex={activeIndex}
        />,
      tab: 
        <Tab
          key={`tab${i}`}
        >{tab.iconPath ?
          <img src={tab.iconPath} alt={tab.title} />
          : tab.icon()
          }
        </Tab>
      })
    );
  }

  render() {
    const { installMessageType, showNotificationPrompt, currentIndex } = this.state;

    const tutorialSlides = [
      { 
        title: "Install on iOS", 
        description: [
          "1. Open Safari and navigate to this website.",
          "2. Tap the 'Share' button at the bottom of the screen.",
          "3. Scroll down and select 'Add to Home Screen'.",
          "4. Tap 'Add' in the top-right corner."
        ]
      },
      { 
        title: "Install on Android", 
        description: [
          "1. Open Chrome and navigate to this website.",
          "2. Tap the three-dot menu in the top-right corner.",
          "3. Select 'Install App' or 'Add to Home screen'.",
          "4. Confirm by tapping 'Install' or 'Add'."
        ]
      },
      { 
        title: "Other Browsers", 
        description: [
          "For Edge, Firefox, and other browsers, look for the 'Add to Home Screen' or 'Install' option in the browser menu."
        ]
      }
    ];
    
    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === tutorialSlides.length - 1;

    return (
      <Page renderToolbar={this.renderToolbar}>
        <Dialog isOpen={showNotificationPrompt}>
          <div className="c-modal--notification-dialog">
            <Icon
              className="c-modal--notification-dialog__close"
              size={{default: 26, material: 26}}
              icon={{default: 'ion-ios-close', material: 'md-close'}}
              onClick={() => this.setState({showNotificationPrompt: false})}
            />

            <img src='/images/logo.png' className="c-modal--notification-dialog__allow-notifications" alt="App logo" />

            <p>Allow notifications from Quicky?</p>

            <div>
              <Button id="allow_notifications_btn" onClick={() => this.setState({showNotificationPrompt: false})}>Allow</Button>
              <Button className="u-ml-1" onClick={() => this.setState({showNotificationPrompt: false})}>Cancel</Button>
            </div>
          </div>
        </Dialog>

        <ActionSheet 
          isOpen={installMessageType !== ''} 
          isCancelable={true} 
          maskColor="rgba(0, 0, 0, 0.75)"
        >
            <SwipeableViews index={currentIndex} onChangeIndex={this.handleSwipeIndexChange} style={{ overflow: 'hidden' }}>
              {tutorialSlides.map((slide, index) => (
                <div className="c-add-to-home" key={index}>
                  <img src="/images/image-notify.png" alt="" className="c-add-image"/>
                  <p className="c-add-home-heading-txt">{slide.title}</p>
                  <div className="c-add-home-shead">
                    {slide.description.map((step, index) => (
                      <p key={index}>{step}</p>
                    ))}
                  </div>

                  <div className="c-add-to-home__indicator">
                    {tutorialSlides.map((_, i) => (
                      <span
                      key={i}
                      className={`indicator-dot ${i === currentIndex ? 'active' : ''}`}
                      onClick={() => this.handleSwipeIndexChange(i)} // Make dot clickable
                      style={{ cursor: 'pointer', margin: '0 5px' }}
                    ></span>
                    ))}
                  </div>
                  <div className="c-add-to-home__button">
                    {isFirstSlide && (
                      <Button onClick={() => this.setState({ installMessageType: "" })}>
                        Skip
                      </Button>
                    )}
                    {!isFirstSlide && !isLastSlide && (
                      <Button onClick={this.handleNext}>
                        Next
                      </Button>
                    )}
                    {isLastSlide && (
                      <Button onClick={() => this.setState({ installMessageType: "" })}>
                        Finish
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            </SwipeableViews>

        </ActionSheet>

        <Tabbar
          position="bottom"
          index={this.state.active}
          renderTabs={this.renderTabs}
          onPreChange={() => this.setState({showToolbar: true})}
          onPostChange={e => this.setState({active: e.activeIndex})}
          swipeable={false}
        />
      </Page>
    );
  }
}

export default TabBar;